




import { Mixins } from "vue-property-decorator";
import DecoratorMixin from '../mixin';

export default abstract class Decorator extends Mixins(DecoratorMixin) {
   abstract text: string;
}
